//GET_TYPE

export const GET_PRODUCTS_LOADING='get/productsLoading';
export const GET_PRODUCTS_ERROR='get/productsError';
export const GET_MENS_SUCCESS='get/mansSuccess';
export const GET_WOMENS_SUCCESS='get/womensSuccess';
export const GET_KIDS_SUCCESS='get/kidsSuccess';
export const GET_USERSLIST_SUCCESS='get/usersList';
export const GET_ADMINDATA_SUCCESS='get/adminData';
export const GET_CURRENT_USER='get/currentUser';


//ADD_TYPE
export const ADD_MENS_SUCCESS='add/mensSuccess';
export const ADD_WOMENS_SUCCESS='add/womensSuccess';
export const ADD_KIDS_SUCCESS='add/kidsSuccess';
export const ADD_ADMIN_NAME='add/adminName';
export const ADD_ADMIN_EMAIL='add/adminEmail';
export const ADD_ADMIN_CONTACT='add/adminContact';
export const ADD_ADMIN_PASSWORD='add/adminPassword';
export const ADD_USERSLIST_DATA= 'add/usersList';
export const ADD_CURRENT_USER='add/currentUser';

//DELETE-TYPE
export const DELETE_PRODUCT_MENS='delete/mens';
export const DELETE_PRODUCT_WOMENS='delete/womens';
export const DELETE_PRODUCT_KIDS='delete/kids';
export const DELETE_USERSLIST_DATA='delete/usersList';


//UPDATE_TYPE
export const UPDATE_PRODUCT_MENS='update/mens';
export const UPDATE_PRODUCT_WOMENS='update/womens';
export const UPDATE_PRODUCT_KIDS='update/kids';
export const UPDATE_USERSLIST_DATA='update/userslist';
export const UPDATE_CURRENT_USER='update/currentUser';